export const DOWNLOAD_INVOICING_REPORT_REQUEST = "DOWNLOAD_INVOICING_REPORT_REQUEST";
export const DOWNLOAD_INVOICING_REPORT_SUCCESS = "DOWNLOAD_INVOICING_REPORT_SUCCESS";
export const DOWNLOAD_INVOICING_REPORT_FAILURE = "DOWNLOAD_INVOICING_REPORT_FAILURE";
export const DOWNLOAD_INVOICING_REPORT_RESET = "DOWNLOAD_INVOICING_REPORT_RESET";
export const downloadInvoicingReportRequest = (payload) => ({
    type: DOWNLOAD_INVOICING_REPORT_REQUEST,
    payload,
});
export const downloadInvoicingReportSuccess = (payload) => ({
    type: DOWNLOAD_INVOICING_REPORT_SUCCESS,
    payload,
});
export const downloadInvoicingReportFailure = (payload) => ({
    type: DOWNLOAD_INVOICING_REPORT_FAILURE,
    payload,
});
export const downloadInvoicingReportReset = () => ({
    type: DOWNLOAD_INVOICING_REPORT_RESET,
});
